import {Component, OnDestroy, OnInit, ChangeDetectorRef} from '@angular/core';
import {Subscription} from 'rxjs';
import {LoaderService} from './service/loader.service';

@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  isLoading = false;
  private subscription: Subscription = new Subscription();

  constructor(private loaderService: LoaderService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    const sub = this.loaderService.isLoaderOn.subscribe(res => {
      this.isLoading = res;
      this.cdr.detectChanges();
    });

    if (this.subscription) {
      this.subscription.add(sub);
    }

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
